import { Injectable } from "@angular/core";
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { TreeControlService } from "./tree-control.service";
import { TreeDataSourceService } from "./tree-data-source.service";

@Injectable()
export class TreeScrollService {
  private scrollableTree: CdkVirtualScrollViewport;

  constructor(
    public treeControl: TreeControlService,
    private dataSource: TreeDataSourceService
  ) {}

  public init(scrollableTree: CdkVirtualScrollViewport): void {
    this.scrollableTree = scrollableTree;
  }
}
